export default "__VITE_ASSET__b679ac45__"